import { render, staticRenderFns } from "./CarouselForm.vue?vue&type=template&id=4264978a&scoped=true"
import script from "./CarouselForm.vue?vue&type=script&lang=js"
export * from "./CarouselForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264978a",
  null
  
)

export default component.exports